export function createBasicScreenSchema(type: string, properties = {}, required: string[] = []) {
  return {
    type: 'object',
    properties: {
      id: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          type: { enum: [type] },
          ...properties,
        },
        additionalProperties: false,
        required: ['type', ...required],
      },
    },
    additionalProperties: false,
    required: ['id', 'data'],
    definitions: {},
  } as const;
}
